import React, { useEffect ,useState} from "react";
import { ToastContainer, toast } from "react-toastify";
import { useForm, useFieldArray } from "react-hook-form";
import { API } from "aws-amplify";
import closeImg from "../Resources/svg/cancel.svg";
import { validatorRate, validatorRateNegative } from "../Utils/validators";

export default function Config({ open, close, idConfig }) {
  const { handleSubmit, register, errors, control } = useForm();
  const [ isActive, setIsActive ] = useState(false);
  const { fields, append } = useFieldArray({
    control,
    name: "rescate"
  });
  const { fields: penalidadFields, append: penalidadAppend } = useFieldArray({
    control,
    name: "rescateConPenalidad"
  });

  const closeModal = () => {
    close(idConfig);
  };

  useEffect(() => {
    getRescueRates();
  }, []);

  const onSubmit = (data) => {
    saveRecueRates(data);
  };

  const getRescueRates = async () => {
    const response = await API.get("api-rentas", "/producto/configmin/AS");
    if (response.rescate) {
      append(response.rescate);
      penalidadAppend(response.rescateConPenalidad);
      setIsActive(true);
    }
  };

  const saveRecueRates = async values => {
    const data = values.rescate.map(item => ({
      ...item,
      plazo: Number(item.plazo),
      tasa: Number(item.tasa)
    }));
    const dataPenalidad = values.rescateConPenalidad.map(item => ({
      ...item,
      plazo: Number(item.plazo),
      tasa: Number(item.tasa)
    }));
    const request = {
      body: {
        rescate: data,
        rescateConPenalidad: dataPenalidad,
      }
    };
    const response = await API.post("api-rentas", "/producto/configmin/AS", request);
    if (response.status !== 200) {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-modal"
      });
    }
    else {
      toast.success(response.message, {
        position: toast.POSITION.TOP_CENTER,
        className: "toast-modal-success"
      });
    }
  };

  return (
    <div className={`modalFormRG  ${open ? "is-open" : ""}`}>
      <div className="modalFormRG__container">
        <img
          src={closeImg}
          alt="imgClose"
          className="modalFormRG__container__button"
          onClick={closeModal}
        />
        <div className="configFormAS">
          <div className="configFormAS__container-titles">
            <p className="configFormAS__container-titles__title">
              Configuración <span>Tasas de Rescate</span>
            </p>
            <p className="configFormAS__container-titles__sub-title">
              Configura aquí las tasas de rescate para Ahorro Seguro
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="configFormAS__form">
            <div className="configFormAS__container">
              <div className="configFormAS__container-titles">
                <p className="configFormAS__container-titles__sub-title">
                  Tasas de rescate <b>sin penalidad</b>
                </p>
              </div>
              {fields.map((item, index) => 
                <div key={item.id}>
                  <div className="configFormAS__form__input" >
                    <label style={{ fontSize: "1rem" }}>Tasa Año {item.plazo}</label>
                    <input 
                      type="hidden"
                      name={`rescate[${index}].plazo`}
                      ref={register()}
                      value={item.plazo}
                    />
                    <input
                      name={`rescate[${index}].tasa`}
                      ref={register({ validate: (value) => (index === 0) ? validatorRateNegative(value) : validatorRate(value) })}
                      defaultValue={item.tasa}
                      autoComplete="off"
                    />
                    <div className="errorCustom">{errors.rescate && errors.rescate[index] ? errors.rescate[index].tasa.message : ''}</div>
                  </div>
                </div>
              )}
            </div>

            <div className="configFormAS__container">
              <div className="configFormAS__container-titles">
                <p className="configFormAS__container-titles__sub-title">
                  Tasas de rescate <b>con penalidad</b>
                </p>
              </div>
              {penalidadFields.map((item, index) => 
                <div key={item.id}>
                  <div className="configFormAS__form__input" >
                    <label style={{ fontSize: "1rem" }}>Tasa Año {item.plazo}</label>
                    <input 
                      type="hidden"
                      name={`rescateConPenalidad[${index}].plazo`}
                      ref={register()}
                      value={item.plazo}
                    />
                    <input
                      name={`rescateConPenalidad[${index}].tasa`}
                      ref={register({ validate: (value) => (index === 0) ? validatorRateNegative(value) : validatorRate(value) })}
                      defaultValue={item.tasa}
                      autoComplete="off"
                    />
                    <div className="errorCustom">{errors.rescateConPenalidad && errors.rescateConPenalidad[index] ? errors.rescateConPenalidad[index].tasa.message : ''}</div>
                  </div>
                </div>
              )}
            </div>
            
            <div className="configFormAS__form__btn-container">
              <button
                id="button_quote_vas2"
                type="submit"
                className="configFormAS__form__btn-container__btn"
                disabled={!isActive}
              >
                GUARDAR
              </button>
            </div>
          </form>
          <ToastContainer containerId={"A"} />
        </div>
      </div>
    </div>
  );
};